var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_9_15",
    "data-name": "Component 9 \\u2013 15",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12736",
    "data-name": "Group 12736",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12688",
    "data-name": "Path 12688",
    d: "M132.1,5.382c.045.013.089.028.135.039a.991.991,0,0,1,.807.9c0,.191,0,.383,0,.6h.175q1.138,0,2.276,0c.712,0,1.19.4,1.191,1,0,.241,0,.482,0,.734H123.7a6.251,6.251,0,0,1,.01-.964,1.042,1.042,0,0,1,1.1-.774c.775,0,1.55,0,2.325,0h.19c0-.179,0-.346,0-.514a.992.992,0,0,1,.9-1,.187.187,0,0,0,.04-.021ZM130.18,6.913c.547,0,1.094,0,1.642,0,.132,0,.189-.034.181-.149a2.976,2.976,0,0,1,0-.369c.006-.109-.049-.144-.173-.141-.244.005-.487,0-.731,0-.85,0-1.7,0-2.552,0-.14,0-.2.035-.189.156a1.994,1.994,0,0,1,0,.341c-.012.129.051.164.2.163C129.1,6.91,129.638,6.913,130.18,6.913Z",
    transform: "translate(-123.683 -2.382)",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12689",
    "data-name": "Path 12689",
    d: "M131.908,35.116h10.315c0,.047,0,.091,0,.134q-.156,2.011-.314,4.022-.17,2.147-.345,4.294-.019.232-.037.464a1.063,1.063,0,0,1-1.174.923q-2.682,0-5.364,0c-.4,0-.8,0-1.2,0a1.064,1.064,0,0,1-1.179-.932q-.221-2.76-.443-5.521-.131-1.636-.256-3.272C131.906,35.2,131.908,35.164,131.908,35.116Zm6.721,7.626a.469.469,0,0,0,.478.46.5.5,0,0,0,.562-.427q.049-.47.1-.939l.278-2.682c.048-.463.1-.925.14-1.389a.466.466,0,0,0-.492-.468.5.5,0,0,0-.544.413c-.012.109-.023.218-.034.327q-.139,1.341-.278,2.682C138.767,41.386,138.7,42.053,138.629,42.742Zm-3.123-.006c-.014-.142-.029-.292-.045-.442q-.14-1.348-.28-2.7c-.066-.635-.129-1.271-.2-1.906a.489.489,0,0,0-.481-.4.512.512,0,0,0-.54.336.657.657,0,0,0-.006.23c.036.363.078.726.115,1.089q.2,1.919.4,3.839a.5.5,0,0,0,.548.41A.48.48,0,0,0,135.505,42.736Zm1.042-2.5v.506c0,.67,0,1.34,0,2.009a.473.473,0,0,0,.466.45.518.518,0,0,0,.561-.348.737.737,0,0,0,.012-.177q0-2.372,0-4.743c0-.073,0-.146,0-.219a.438.438,0,0,0-.333-.387.508.508,0,0,0-.705.435C136.545,38.587,136.547,39.411,136.547,40.236Z",
    transform: "translate(-130.571 -27.953)",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.75bf049a5b6e87c1c79d2abfaf09e8d5.svg";
export { ForwardRef as ReactComponent };